module.exports = __webpack_public_path__ + "checkmark.598b3c992f1a63fdd633e68d455668aa.svg";